import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';

/**
 * Chrome for the public job routes: `/oferta-laboral/:slug` and `/postulacion/:token`.
 * Unlike `PublicLayoutComponent` the logo is not a link: `/` leads to the recruiter
 * login, and these pages must not point candidates to authenticated flows.
 */
@Component({
  selector: 'rec-public-chrome-layout',
  standalone: true,
  imports: [RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex min-h-screen flex-col bg-white">
      <header class="border-b border-brand-border bg-white">
        <div class="container mx-auto flex items-center px-4 py-4 sm:px-6 lg:px-8">
          <img
            src="https://storage.googleapis.com/tribuu-public/assets/images/logo.png"
            alt="Tribuu"
            class="h-10 w-auto object-contain sm:h-11 lg:h-12"
          />
        </div>
      </header>
      <main class="flex-1">
        <router-outlet></router-outlet>
      </main>
      <footer class="border-t border-brand-border bg-white py-4">
        <div
          class="container mx-auto flex flex-col items-center gap-2 px-4 font-futura-medium text-xs text-gray-tribuu-700 sm:flex-row sm:justify-between sm:px-6 lg:px-8"
        >
          <a
            routerLink="/info/aviso-de-privacidad"
            target="_blank"
            rel="noopener noreferrer"
            class="underline underline-offset-2 hover:text-brand-navy"
          >
            Aviso de privacidad
          </a>
          <span>© Tribuu</span>
        </div>
      </footer>
    </div>
  `,
})
export class PublicChromeLayoutComponent {}
